import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=6ec210da&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports